module.exports = __webpack_public_path__ + "static/Boom-0c2ef5063a7312e3010b41f88308a9f0.gif";